import { render, staticRenderFns } from "./InsuranceCompanyAdd.vue?vue&type=template&id=d4a31a5e&scoped=true&"
import script from "./InsuranceCompanyAdd.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a31a5e",
  null
  
)

export default component.exports